import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";
import "./App-responsive.css";
import "./app-extra.css";
import Router from "./Router/Router";
import Alert from './components/Alert';
import { useSelector } from "react-redux";
import React, {useEffect} from "react";
import {  useDispatch } from 'react-redux'
import { updateUser } from './redux/userSlice'

import { getLocalData } from "./utils/localStorage";


import { getCartItems } from "./services/CartService";

import { addTOCart } from "./redux/cartSlice";
import { getPharmacySettingRedux } from "./redux/pharmacySlice";


function App() {

  const alertMsg = useSelector((state) => state.alert.alertMsg);
  const alertState = useSelector((state) => state.alert.alertState);
  const alertIsEnabled = useSelector((state) => state.alert.isEnabled);
  const pharmacyName = useSelector((state) => state.pharmacy.pharmacyDetails.pharmacy.pharmacyName);
  
  const dispatch = useDispatch()

  let loggedIn = getLocalData("user-info")?.userToken?.length > 0 ? true : false;

  useEffect(() => {
   if(loggedIn){
    dispatch(updateUser( getLocalData("user-info")?.userData))


    getCartItems(getLocalData("user-info")?.userToken).then(
      (res) => {
       
      
       dispatch(addTOCart(res))
      },
      (failure) => {
        console.error(failure); //expected output: Oopsy...
      }
    );
   }else{

   }
    
  }, [dispatch,loggedIn]);
  

  useEffect(() => {
   dispatch(getPharmacySettingRedux())
  }, [])
 

  useEffect(() => {
    if(pharmacyName){
      
      document.title = pharmacyName;
    }
    
    
  }, [pharmacyName])
  


  return (
    <>
    {alertIsEnabled && <Alert msg={alertMsg} state={alertState} isEnabled={alertIsEnabled}/>}
    <Router/>
    </>
    
    
    
  );
}

export default App;
